/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Card, Grid, TextField } from "@mui/material";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import WarningModal from "components/displayModel/warningModel";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  getPickupChargesById,
  saveConsignmentPickupCharges,
  updatefetchPickupChargesByID,
} from "utils/api";
import {
  blank,
  getScreenRight,
  showResMsg,
  validateField,
} from "utils/generic";
import { genericMessage } from "utils/genericMessages";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};

let fetchCargoPickup;

let LOGIN_DETAILS;

function AddCargoPickupCharges() {
  const { id } = useParams();
  const { shipmentChargeID } = useParams();
  const [screenName, setScreenName] = useState(
    "Add Cargo Local Pickup Charges"
  );
  const [loading, setLoading] = useState(false);
  const [cpcZoneNameErr, setCpcZoneNameErr] = useState(false);
  const [cpcFromDistanceErr, setCpcFromDistanceErr] = useState(false);
  const [cpcToDistanceErr, setCpcToDistanceErr] = useState(false);
  const [cpcPickupChargesErr, setCpcPickupChargesErr] = useState(false);
  const [confirmDialogeFlag, setConfirmDialogeFlag] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [errCargoPickup, setErrCargoPickup] = useState("");

  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let mandateFlag = false;

  const [cargopick1, setCargopick1] = useState({
    cpcZoneName: "",
    cpcToDistance: "",
    cpcFromDistance: "",
    cpcPickupCharges: "",

    shipmentChargeID,
  });

  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"));
  cargopick1.businessUserID = LOGIN_DETAILS.businessUserID;

  const handleChangePick = (name) => (event) => {
    if (event.target.validity.valid) {
      setCargopick1({ ...cargopick1, [name]: event.target.value });
    }
  };

  const fromDistance = parseInt(cargopick1.cpcFromDistance);
  const toDistance = parseInt(cargopick1.cpcToDistance);

  useEffect(() => {
    if (id !== undefined) {
      setScreenName("Edit Cargo Local Pickup Charges");
      cargopick1._id = id;
      getPickupChargesById(
        cargopick1,
        (data) => {
          if (data.Result_Output.length > 0) {
            let selectedIDData;
            for (let pickup of data.Result_Output) {
              if (pickup._id === id) {
                selectedIDData = pickup;
              }
            }
            fetchCargoPickup = data.Result_Output;
            setCargopick1(selectedIDData);
          }
        },
        dispatch
      );
    }
    getRight();
  }, []);
  async function getRight() {
    let right = await getScreenRight("Shipment Charges");
    if (right === "Full Access") {
      setDisableColor(false);
    } else setDisableColor(true);
  }

  const addCargoPickup = () => {
    let cargoPickupErr = false;
    sessionStorage.setItem("PARA_TABLE", "ConsignmentPickupCharges");
    mandateFlag =
      validateField(cargopick1.cpcZoneName, setCpcZoneNameErr) || mandateFlag;
    if (cargopick1.cpcFromDistance.toString().trim() === "") {
      setCpcFromDistanceErr("From Distance can't be blank");
      mandateFlag = true;
    } else setCpcFromDistanceErr(false);
    if (cargopick1.cpcToDistance.toString().trim() === "") {
      setCpcToDistanceErr("To Distance can't be blank");
      mandateFlag = true;
    } else if (cargopick1.cpcFromDistance === cargopick1.cpcToDistance) {
      setCpcToDistanceErr("To Distance can't be same as From Distance");
      mandateFlag = true;
    } else if (toDistance < fromDistance) {
      setCpcToDistanceErr("To Distance must be greater than From Distance");
      mandateFlag = true;
    } else setCpcToDistanceErr(false);
    if (cargopick1.cpcPickupCharges.toString().trim() === "") {
      setCpcPickupChargesErr("Cargo Pickup Charges can't be blank");
      mandateFlag = true;
    } else setCpcPickupChargesErr(false);

    if (mandateFlag) {
      return;
    }
    if (id === undefined || id === "") {
      cargopick1.shipmentChargeID = shipmentChargeID;
      saveConsignmentPickupCharges(
        cargopick1,
        (data) => {
          showResMsg(
            data.Result_Status ? genericMessage.added : data.Result_Message,
            1000,
            data.Result_Status,
            navigate,
            "/shipmentCharges"
          );
        },
        dispatch
      );
    } else {
      for (let i = 0; i < fetchCargoPickup.length; i++) {
        if (fetchCargoPickup[i]._id === id) {
          if (fetchCargoPickup[i].cpcFromDistance !== 0) {
            if (
              fetchCargoPickup[i - 1].cpcToDistance + 1 !==
              parseInt(cargopick1.cpcFromDistance)
            ) {
              cargoPickupErr = true;
              setErrCargoPickup("From Distance");
            }
            if (
              fetchCargoPickup[i - 1].cpcToDistance >
              parseInt(cargopick1.cpcFromDistance)
            ) {
              cargoPickupErr = true;
              setErrCargoPickup("From Distance");
            }
            if (fetchCargoPickup[i + 1]) {
              if (
                fetchCargoPickup[i + 1].cpcFromDistance <
                parseInt(cargopick1.cpcToDistance)
              ) {
                setErrCargoPickup("To Distance");
                cargoPickupErr = true;
              } else if (
                fetchCargoPickup[i + 1].cpcFromDistance - 1 !==
                parseInt(cargopick1.cpcToDistance)
              ) {
                setErrCargoPickup("To Distance");
                cargoPickupErr = true;
              }
            }
          } else {
            if (fetchCargoPickup[i + 1]) {
              if (
                fetchCargoPickup[i + 1].cpcFromDistance <
                parseInt(cargopick1.cpcToDistance)
              ) {
                setErrCargoPickup("To Distance");
                cargoPickupErr = true;
              } else if (
                fetchCargoPickup[i + 1].cpcFromDistance - 1 !==
                parseInt(cargopick1.cpcToDistance)
              ) {
                setErrCargoPickup("To Distance");
                cargoPickupErr = true;
              }
            }
          }
        }
      }
      if (!cargoPickupErr) {
        updatefetchPickupCharges();
      } else {
        setConfirmDialogeFlag(true);
      }
    }
  };

  const handleCancel = (name) => (event) => {
    setConfirmDialogeFlag(false);
  };

  const handleChangeValue = async (id) => {
    updatefetchPickupCharges();
    setConfirmDialogeFlag(!confirmDialogeFlag);
  };

  const updatefetchPickupCharges = async () => {
    updatefetchPickupChargesByID(
      cargopick1,
      (data) => {
        showResMsg(
          data.Result_Status ? genericMessage.updated : data.Result_Message,
          1000,
          data.Result_Status,
          navigate,
          "/shipmentCharges"
        );
      },
      dispatch
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          <Grid item xs={10} spacing={6}>
            <Card sx={{ boxShadow: "none" }}>
              <MDBox
                mx={2}
                mt={-3}
                mb={1.5}
                py={2}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {screenName}
                </MDTypography>
              </MDBox>
              <MDBox pt={4} pb={3} px={3}>
                <Grid container columnSpacing={5}>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="Zone Name"
                          variant="outlined"
                          fullWidth
                          autoFocus={true}
                          inputProps={{
                            pattern: "^[a-zA-Z0-9 ]*$",
                            maxLength: 20,
                          }}
                          onChange={handleChangePick("cpcZoneName")}
                          value={cargopick1.cpcZoneName}
                        />
                        {cpcZoneNameErr ? (
                          <p style={errMsg}>Zone Name can't be blank</p>
                        ) : (
                          ""
                        )}
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="From Distance (Km)"
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            pattern: "^[0-9]+$",
                            maxLength: 5,
                          }}
                          disabled={
                            parseInt(cargopick1.cpcFromDistance) === 0 &&
                            typeof id != "undefined"
                              ? true
                              : false
                          }
                          onChange={handleChangePick("cpcFromDistance")}
                          value={cargopick1.cpcFromDistance}
                        />
                        {cpcFromDistanceErr !== "" ? (
                          <p style={errMsg}>{cpcFromDistanceErr}</p>
                        ) : (
                          ""
                        )}
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="To Distance (Km)"
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            pattern: "^[0-9]+$",
                            maxLength: 5,
                          }}
                          onChange={handleChangePick("cpcToDistance")}
                          value={cargopick1.cpcToDistance}
                        />
                        {cpcToDistanceErr !== "" ? (
                          <p style={errMsg}>{cpcToDistanceErr}</p>
                        ) : (
                          ""
                        )}
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} lg={3}>
                    <MDBox component="form" role="form">
                      <MDBox mb={4} xs={12}>
                        <TextField
                          type="text"
                          label="Local Pickup Charges ($)"
                          variant="outlined"
                          fullWidth
                          inputProps={{
                            pattern: "^[0-9]+$",
                            maxLength: 5,
                          }}
                          onChange={handleChangePick("cpcPickupCharges")}
                          value={cargopick1.cpcPickupCharges}
                        />
                        {cpcPickupChargesErr !== "" ? (
                          <p style={errMsg}>{cpcPickupChargesErr}</p>
                        ) : (
                          ""
                        )}
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          mt={2}
          columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
        >
          <Grid item xs={12} md={4} spacing={2} lg={1.2}>
            <Link to={"/shipmentCharges"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
                onClick={() => {
                  sessionStorage.setItem(
                    "PARA_TABLE",
                    "ConsignmentPickupCharges"
                  );
                }}
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} spacing={2} lg={1.2}>
            <MDButton
              onClick={disableColor ? blank : addCargoPickup}
              rel="noreferrer"
              variant="gradient"
              className={
                "btn-block center-container-btn btn-warning btn-back rightSpace"
              }
              color={disableColor ? "secondary" : "success"}
              fullWidth
            >
              {id !== undefined && id !== "" ? <>Update</> : <>Save</>}
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
      <WarningModal
        open={confirmDialogeFlag}
        errorMesssage={errCargoPickup}
        handleDelete={handleChangeValue}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}

export default AddCargoPickupCharges;
